/**
 * The placeholder shown wherever a profile or default avatar has no image of its own.
 *
 * Astryx's `Avatar` falls back to the person's initials when `src` is absent. This replaces that
 * with a neutral silhouette, so an account with no photo reads as "no picture set" rather than as
 * a monogram — the behaviour asked for on 2026-08-11.
 *
 * It is an inline SVG data URI rather than a file in `public/` on purpose: it costs no network
 * request, stays crisp at every `Avatar` size from `tiny` (20px) to `large` (128px), and cannot
 * 404 the way a missing asset path would. Encoded at module load rather than by hand so the
 * markup below stays readable and editable.
 *
 * `Avatar` still receives `name`, which supplies the alt text — the silhouette is decorative, and
 * a screen reader should still hear whose avatar this is.
 */
const PLACEHOLDER_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
  <rect width="512" height="512" fill="#5669cb"/>
  <circle cx="256" cy="197" r="86" fill="#c6d1f0"/>
  <ellipse cx="256" cy="486" rx="150" ry="168" fill="#c6d1f0"/>
</svg>`

export const DEFAULT_AVATAR_IMAGE = `data:image/svg+xml,${encodeURIComponent(PLACEHOLDER_SVG)}`
